<script lang="ts">
    import { onMount } from 'svelte';
    let canvas;
    onMount(() => {
        const ctx = canvas.getContext('2d');
        let frame;
        (function loop() {
            frame = requestAnimationFrame(loop);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            for (let p = 0; p < imageData.data.length; p += 4) {
                const i = p / 4;
                const x = i % canvas.width;
                const y = i / canvas.height >>> 0;
                const t = window.performance.now();
                const r = 15 + (50 * x / canvas.width) + (40 * Math.sin(t / 1000));
                const g = 75;
                const b = 120;
                imageData.data[p + 0] = r;
                imageData.data[p + 1] = g;
                imageData.data[p + 2] = b;
                imageData.data[p + 3] = 150;
            }
            ctx.putImageData(imageData, 0, 0);
        }());
        return () => {
            cancelAnimationFrame(frame);
        };
    });
</script>

<canvas
        bind:this={canvas}
        width={32}
        height={32}
></canvas>

<style>
    canvas {
        opacity: 0.6;
        position: fixed;
        z-index: -20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #666;
    }
</style>